import styled from 'styled-components';

import { colors } from 'styles';

export const Container = styled.div`
  position: relative;
  z-index: 10;

  span {
    width: max-content;
    max-width: 16rem;
    background: var(--primary_color);
    padding: 0.8rem;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden;

    position: absolute;
    bottom: calc(100% + 1.2rem);
    left: 50%;
    transform: translateX(-50%);
    color: ${colors.text_white};

    &::before {
      content: '';
      border-style: solid;
      border-color: var(--primary_color) transparent;
      border-width: 0.6rem 0.6rem 0 0.6rem;
      top: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
